// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ViajesPage from './pages/ViajesPage';
import PersonalPage from './pages/PersonalPage';
import ProvinciasPage from './pages/ProvinciasPage';
import UsuariosPage from './pages/UsuariosPage';
import Layout from './components/Layout';

const ProtectedRoute = ({ children, adminOnly }) => {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <div style={{display:'flex',justifyContent:'center',marginTop:80}}>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && !isAdmin) return <Navigate to="/" />;
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="viajes" element={<ViajesPage />} />
        <Route path="personal" element={<PersonalPage />} />
        <Route path="provincias" element={<ProtectedRoute adminOnly><ProvinciasPage /></ProtectedRoute>} />
        <Route path="usuarios" element={<ProtectedRoute adminOnly><UsuariosPage /></ProtectedRoute>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;